import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AccessResponse, SelectLogo } from 'src/app/personal-info/models/personal-info.model';
import { environment } from 'src/environments/environment';
import { HttpHandlerService } from 'src/app/shared-resources/services/http-handler.service';
import { UrlMapService } from 'src/app/shared-resources/services/url-map.service';
import { GetBio, MlsAgentDetails, MlsOfficeCompanyDetails, OfficeDetails, OfficePhone,GetOfficeComp } from 'src/app/office-websites/Models/office-website.model';


@Injectable({
  providedIn: 'root'
})
export class OfficeWebsiteService {

  constructor(
    private urlMapService: UrlMapService,
    private https: HttpHandlerService,
    private httpClient: HttpClient
  ) { }

  /** return selected menu */
  get selectedMenu(): string {
    return sessionStorage.getItem('officeSelectedMenu') as string;
  }

  /** update selected office website menu */
  public updateSelectedMenu(menuName: string): void {
    sessionStorage.setItem('officeSelectedMenu', menuName);
  }

  /** get office phone numbers from db */
  public getOfficePhoneNumbers(pcNumber: string): Observable<OfficePhone[]> {
    if(!pcNumber) return of([]);
    let url = this.urlMapService.getOfficePhoneNumbers() + pcNumber + '/phone-numbers';
    return this.httpClient.get<OfficePhone[]>(url);
  }

  /** save office phone numbers */
  public saveOfficePhoneNumbers(pcNumber: string, data: any): Observable<AccessResponse> {
    let url = this.urlMapService.getOfficePhoneNumbers() + pcNumber + '/phone-numbers';
    return this.httpClient.post<AccessResponse>(url, data);
  }

  public updateLMXOfficePhoneNumbers(pcNumber: string, data: any): Observable<any> {
    let url = this.urlMapService.getOfficePhoneNumbers() + pcNumber + '/phone-numbers';
    return this.httpClient.put<any>(url, data);
  }

    /** get social network links for office website menu */
    getOfficeSocialNetworkAffiliations(pcNumber: string): Observable<any> {
      if(!pcNumber) return of({});
      const url = environment.base_url + "/v1/office/" + pcNumber + "/social-networks";
      const opts = { observe: 'response' };
      return this.https.get(url, opts);
    }

     /** save social network affiliation for office website menu */
  public saveOfficeSocialNetworkAffiliations(data: any): Observable<AccessResponse> {
    let url = this.urlMapService.saveSocialNetworkAffilaitions();
    return this.httpClient.post<AccessResponse>(url, data);
  }

  /** get office manager information */
  public getOfficeManagerInfo(pcNumber: string): Observable<OfficeDetails> {
    if(!pcNumber) return of(new OfficeDetails());
    let url = this.urlMapService.getOfficePhoneNumbers() + pcNumber + '/information';
    return this.httpClient.get<OfficeDetails>(url);
  }

  public getLogos(pcNumber: string): Observable<SelectLogo> {
    if(!pcNumber) return of(new SelectLogo());
    let url = this.urlMapService.getOfficeLogos() + pcNumber + '/logos';
    return this.httpClient.get<SelectLogo>(url);
  }

  public saveDefaultLogo(pcNumber: string, id: number): Observable<AccessResponse> {
    let url = this.urlMapService.getOfficeLogos() + 'logos?' + 'pcNumber=' + pcNumber + '&selectedLogoId=' + id;
    return this.httpClient.post<AccessResponse>(url, null);
  }
  /** get office dropdown values for office website menu */
  getOfficeTypeValues(pcNumber: string, type: string): Observable<any> {
    if(!pcNumber) return of({});
    const url = environment.base_url + "/v1/office/" + pcNumber + "/" + type;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** upload Images */
  uploadPhotos(reqObj: any, id: any) {
    const url = this.urlMapService.uploadOfficePhotosUrl() + 'officeId=' + id;
    return this.https.post(url, reqObj);
  }

  /** get photos api method */
  getPhotosUrl(pcNumber: any) {
    if(!pcNumber) return of({});
    const url = this.urlMapService.getOfficePhotosUrl() + pcNumber + '/photos';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** save default/delete photo method here */
  savePhotos(req: any) {
    const url = this.urlMapService.saveImagesUrl();
    return this.https.put(url, req);
  }


  /** get Team Role info */
  getWebsiteAccountDetails(pcNumber: string) {
    if(!pcNumber) return of({});
    const url = this.urlMapService.getOfficeWebsiteAccountInfo() + '/' + pcNumber;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** API to save websiteAccount data */
  publishWebsite(data: any): Observable<AccessResponse> {
    const url = this.urlMapService.getOfficeWebsiteAccountInfo();
    return this.httpClient.post<AccessResponse>(url, data);
  }
  /** get office details for mls companies */
  public getOfficeMlsCompanies(pcNumber: string): Observable<MlsOfficeCompanyDetails> {
    if(!pcNumber) return of(new MlsOfficeCompanyDetails());
    let url = this.urlMapService.getMlsCompaniesDetails() + pcNumber + '/office-mls-companies';
    return this.httpClient.get<MlsOfficeCompanyDetails>(url);
  }

  /**add mls office details */
  public addOfficeMls(data: any, pcNumber: string): Observable<any> {
    let url = this.urlMapService.saveOfficeMls() + '?pcNumber=' + pcNumber;
    return this.httpClient.post<any>(url, data);
  }

  /** check if duplicate office details exist for mls companies */
  public checkDuplicateOfficeMlsExists(mlsCompanyId: number, officeMlsNumber: any): Observable<any> {
    let url = this.urlMapService.getDuplicateOfficeMls() + mlsCompanyId + '/check-exists?officeMlsNumber=' + officeMlsNumber;
    return this.httpClient.get<any>(url);
  }

  /** get agent details for mls companies */
  public getMlsAgentDetails(pcNumber: string): Observable<MlsAgentDetails[]> {
    if(!pcNumber) return of([]);
    let url = this.urlMapService.getMlsCompaniesDetails() + pcNumber + '/agent-mls-companies';
    return this.httpClient.get<MlsAgentDetails[]>(url);
  }

  /** get office biography details */
  getBio(pcNumber: any): Observable<GetBio> {
    if(!pcNumber) return of(new GetBio());
    const url = this.urlMapService.getOfficePhoneNumbers() + pcNumber + '/biography';
    return this.httpClient.get<GetBio>(url);
  }

  /** save office biography details */
  saveBio(data: any): Observable<AccessResponse> {
    const url = this.urlMapService.getOfficePhoneNumbers() + 'biography';
    return this.httpClient.post<AccessResponse>(url, data);
  }


  /** get office video details  */
  getOfficeVideoDetails(pcNumber: string) {
    if(!pcNumber) return of({});
    const url = this.urlMapService.getOfficeLogos() + pcNumber + '/' +'video-details';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  
  /** save office video details */
  saveOfficeVideoDetails(data: any): Observable<AccessResponse> {
    const url = this.urlMapService.getOfficeLogos() +'video-details';;
    return this.httpClient.post<AccessResponse>(url, data);
  }

    public getOfficeCompensationDetails(pcNumber: string): Observable<GetOfficeComp[]> {
      if(!pcNumber) return of([]);
      let url = this.urlMapService.getMlsCompaniesDetails() + pcNumber + '/compensation';
      return this.httpClient.get<GetOfficeComp[]>(url);
    }

    saveOfficeCompensationDetails(data: any): Observable<any> {
       let url = this.urlMapService.getMlsCompaniesDetails() + 'office-compensation';
       return this.httpClient.post<any>(url, data);
    }
    saveCompAgreementFile(data: any): Observable<any> {
      let url = this.urlMapService.getMlsCompaniesDetails() + 'comp-agreement';
      return this.httpClient.post<any>(url, data);
   }
}
